module.exports = __webpack_public_path__ + "static/portfolio_dark_1-b1e01efca9dc97e96af5074862c35a0f.png";